<template>
  <el-upload :disabled="isDisabled || uploading" :class="isDisabled || uploading ? 'el-upload-disabled' : ''" ref="uploadRef" action="" :accept="info.accept" :limit="info.limit" :show-file-list="true" :http-request="beforUploadFile"
      :before-upload="['video', 'audio'].includes(this.info.type) ? beforeMediumUpload : beforeFileUpload"
      :auto-upload="true" :drag="fileList.length === 0"
      v-loading="uploading"
      element-loading-text="文件上传中，请不要刷新系统…"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255,0.8)">
    <div class="drag" v-if="fileList.length === 0">
      <el-icon :class="info.iconName"><upload-filled /></el-icon>
      <div class="el-upload__text">
        拖入{{ info.title }}文件或者 <em>点击上传</em>
      </div>
      <div class="el-upload__attention">
        * {{ info.format }}
      </div>
      <div class="el-upload__attention">
        {{info.attention}}
      </div>
    </div>
    <div class="click_upload" v-else>
      <el-button>
        Upload<el-icon class="el-icon--right">
          <Upload />
        </el-icon>
      </el-button>
    </div>
  </el-upload>

</template>

<script>
import { updateQiniu } from '@/utils/index.js'
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    fwId: {
      type: Number,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fileList: [],
      uploadList: [],
      maxUpload: 3,
      uploading: false
    }
  },
  methods: {
    beforeMediumUpload (file) {
      const allowTypes = this.info.accept.split(',')
      const isTypeOK = allowTypes.includes(file.type)
      const isSize = file.size / 1024 / 1024 / 1024 < 10
      if (!isTypeOK) this.$message.warning('请上传指定格式的文件')
      if (!isSize) this.$message.warning('请上传10GB以内的文件')
      return isTypeOK && isSize
    },
    beforeFileUpload (file) {
      const fileTypes = this.info.accept.split(',')
      if (!fileTypes.includes(file.type)) {
        this.$message.warning('请上传PDF/PPT/Word类型的文件')
        return false
      } else if (file.size / 1024 / 1024 > 200) {
        this.$message.warning('文件大小超过200MB!')
        return false
      }
      return true
    },
    beforUploadFile ({ file }) {
      this.uploading = true
      localStorage.setItem('uploading', '1')
      const fileExtension = file.name.split('.').pop().toLowerCase()
      const videoSuffix = ['mp4', 'm4v', 'mov', 'mpg', 'mpeg']
      const audioSuffix = ['mp3', 'wav', 'aac', 'm4a', 'ogg', 'oga', 'flac']
      const fileSuffix = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg']
      const isVideo = videoSuffix.includes(fileExtension)
      const isAudio = audioSuffix.includes(fileExtension)
      const isFile = fileSuffix.includes(fileExtension)
      if (['qt', 'avi', 'wmv', 'mkv', 'flv', 'webm', 'ogv', '3gp', '3g2', 'mpe', 'ts', 'mts', 'm2ts', 'rm', 'rmvb'].includes(fileExtension)) {
        this.$message.warning(`暂不支持.${fileExtension}文件，请上传.mp4、.m4v、.mov、.mpg、.mpeg格式的Video文件`)
        this.uploading = false
        return
      }
      if (!isVideo && !isAudio && !isFile) {
        this.$message.warning(`暂不支持.${fileExtension}文件，请上传指定格式的文件`)
        this.uploading = false
        return
      }
      if (isVideo || isAudio) {
        this.uploadFile({
          file,
          fileFolder: 'aigc',
          fwId: this.fwId,
          fileType: isVideo ? 'Video' : 'Audio',
          successCallback: this.successCallback
        })
        return
      }
      this.analysisFile(file)
    },
    // analysisMedium (file) {
    //   const url = URL.createObjectURL(file)
    //   const p = new Promise((resolve) => {
    //     if (['video/mp4', 'video/quicktime', 'audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/flac', 'audio/x-m4a'].includes(file.type)) {
    //       const filelement = new Audio(url)
    //       filelement.addEventListener('loadedmetadata', function (_event) {
    //         if (['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/flac', 'audio/x-m4a'].includes(file.type)) {
    //           resolve({ duration: filelement.duration, fileType: 'Audio' })
    //         } else if (['video/mp4', 'video/quicktime', 'video/mpeg'].includes(file.type)) {
    //           resolve({ duration: filelement.duration, fileType: 'Video' })
    //         } else {
    //           resolve({ duration: filelement.duration, fileType: '*' })
    //         }
    //       })
    //     } else {
    //       resolve('')
    //     }
    //   })
    //   p.then(async (resolve) => {
    //     this.uploadFile({
    //       filePage: 0,
    //       fileType: resolve.fileType,
    //       fileCount: resolve.duration,
    //       fileFolder: 'aigc',
    //       file,
    //       fwId: this.fwId,
    //       successCallback: this.successCallback
    //     })
    //   })
    // },
    analysisFile (file) {
      const submitInfo = {
        fileType: this.setFileType(file),
        fileSize: this.setfileSize(file.size),
        fileName: file.name,
        fileUrl: '',
        file,
        fwId: this.fwId,
        successCallback: this.successCallback
      }
      this.uploadFile(submitInfo)
    },
    setFileType (file) {
      const fileExtension = file.name?.split('.').pop().toLowerCase()
      switch (true) {
        case ['ppt', 'pptx'].includes(fileExtension):
          return 'PPT'
        case ['pdf'].includes(fileExtension):
          return 'PDF'
        case ['doc', 'docx'].includes(fileExtension):
          return 'Word'
        case ['xlsx', 'xls'].includes(fileExtension):
          return 'Excel'
        case ['png', 'jpg', 'jpeg'].includes(fileExtension):
          return 'Img'
        case fileExtension === 'txt':
          return 'Txt'
      }
    },
    setfileSize (size) {
      const num = Number(size)
      if (num / 1024 < 1024) {
        return (num / 1024).toFixed(2) + ' KB'
      } else if (num / 1024 / 1024 < 1024) {
        return (num / 1024 / 1024).toFixed(2) + ' MB'
      } else {
        return (num / 1024 / 1024 / 1024).toFixed(2) + ' GB'
      }
    },
    successCallback (task) {
      this.$emit('successCallback', task)
    },
    uploadFile (options) {
      const fileExtension = options.file.name.split('.').pop().toLowerCase()
      const title = options.file.name.split('.').slice(0, -1).join('.')
      const qnFileName = `fw${options.fwId}_time${new Date().getTime()}_uid${options.file.uid}.${fileExtension}`
      const that = this
      const task = {
        submitConfig: {
          ...options,
          laowuId: options.fwId,
          fileName: options.file.name,
          fileSize: options.file.size,
          fileUrl: '',
          title
        },
        uploadConfig: {
          file: options.file,
          fileName: qnFileName,
          folder: options.fileFolder || 'aigc',
          key: options.file.uid,
          bucket: 'infoxmed'
        },
        key: options.file.uid,
        progress: {},
        // 0:等待上传 1:上传中 2:上传成功 3:上传失败 4:已保存至数据库 5:数据库保存失败
        uploadState: 0,
        uploadError: '',
        updateQiniu: updateQiniu,
        successCallback: options.successCallback,
        next (res) {
          this.uploadState = 1
          this.progress = res.total
        },
        error (res) {
          this.uploadState = 3
          if (res.QiniuError) {
            this.uploadError = `[${res.QiniuError.name}]:${res.QiniuError.message}`
          }
          that.uploadTask()
        },
        success (res) {
          this.uploadState = 2
          this.submitConfig.fileUrl = res.url
          that.submitFwFile(this)
          that.uploadTask()
        }
      }
      this.uploadList.push(task)
      this.uploadTask()
    },

    async uploadTask () {
      const uploadCount = this.uploadList.filter(item => item.uploadState === 1).length
      if (uploadCount >= this.maxUpload) return
      const find = this.uploadList.find(item => item.uploadState === 0)
      if (!find) {
        this.uploading = false
        return
      }
      find.uploadState = 1
      find.subscription = await find.updateQiniu({
        ...find.uploadConfig,
        next: find.next.bind(find),
        error: find.error.bind(find),
        success: find.success.bind(find)
      })
    },
    // 提交上传文件信息
    // async submitFwFile (item) {
    //   try {
    //     delete item.submitConfig.file
    //     item.submitConfig.fileSize = '' + item.submitConfig.fileSize
    //     item.uploadState = 4
    //     item.successCallback && item.successCallback(item)
    //   } catch (error) {
    //     item.uploadState = 5
    //   }
    // }
    async submitFwFile (item) {
      try {
        const { submitConfig } = item
        const needDuration = ['Video', 'Audio'].includes(submitConfig.fileType)
        if (needDuration) {
          submitConfig.fileCount = await this.getDuration(submitConfig.fileUrl) || 0
          console.log('[upload] duration ->', submitConfig.fileCount)
        }
        delete submitConfig.file
        item.uploadState = 4
        item.successCallback && item.successCallback(item)
      } catch (e) {
        item.uploadState = 5
      } finally {
        this.uploading = false
        localStorage.removeItem('uploading')
      }
    },
    getDuration (url) {
      return new Promise(resolve => {
        const media = new Audio(url)
        media.addEventListener('loadedmetadata', () => resolve(media.duration))
        media.addEventListener('error', () => resolve(0))
        media.load()
        setTimeout(() => resolve(0), 10000)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.file_item {
  position: relative;
  height: 30px;
  font-size: 12px;
  border-radius: 6px;
  background-color: #f5f7fb;

  .uploading_bg {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    background-color: #e1e7f2;
    border-radius: 0 6px 6px 0;
    z-index: 80;
  }
}

.hoverItem {
  &:hover {
    background-color: #e1e7f2;
    .remove_icon {
      display: inline-block;
    }
  }
}
.el-upload-disabled{
  /deep/.el-upload-dragger{
    cursor: not-allowed;
  }
}
/deep/.el-upload-dragger {
  width: 315px;
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.drag {
  position: relative;
  i{
    font-size: 48px;
    color: #c0c4cc;
  }
  .el-upload__text{
    padding: 6px 0 4px 0;
  }
  .el-upload__attention{
    font-size: 12px;
    color: #606266;
  }
}
/deep/.el-upload-list__item-name{
  width: 270px;
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏溢出的部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
/deep/.el-loading-mask{
  z-index: 1;
  border-radius: 6px;
}
</style>
